<template>
    <section class="page-layout h-100 px-2 overflow-auto">
        <header class="page-header">
            <CentralDashboardHeader></CentralDashboardHeader>
        </header>
        <div class="page-content" id="App__Central">
            <PersonalMessageList class="row-span-2" />
            <ActivePatients />
            <UnassignedVisits v-if="showScheduler" />
            <Intake v-if="showIntake" />
            <Scheduled v-if="showScheduler" />
            <MarketingVideo>
                <div class="embed-responsive embed-responsive-1by1 ratio ratio-1*1">
                    <iframe id="hh-video" allowfullscreen src="https://www.youtube.com/embed/PvexmWMy--E"> </iframe>
                </div>
            </MarketingVideo>
            <NewsAndUpdates :class="colSpan" />
        </div>
    </section>
</template>

<script lang="ts" src="./CentralDashboard.ts"></script>
<style src="./CentralDashboard.scss"></style>
